export default __webpack_public_path__ + "static/media/bandeau-2.faf15ac9.png";